import { Button } from "@/src/components/Button";
import { IconButton, Modal, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { TextField } from "../../TextField";
import { WebShopIcon } from "../../../WebShopIcon";

export const TouristOrderInfoModal: React.FC<{
  fields: {
    name: string;
    label: string;
    pattern: any;
    maxLength?: number;
    minLength?: number;
  }[];
  name: string;
  open: boolean;
  title?: string;
  onSubmit: () => void;
  onClose: () => void;
}> = ({
  fields,
  open = false,
  name,
  title = "Умови страхування",
  onSubmit,
  onClose,
}) => {
  const { control } = useFormContext();

  return (
    <Modal
      className="w-full flex-col justify-end max-md:flex"
      open={open}
      onClose={onClose}
    >
      <Stack
        className={
          "flex w-full max-w-[524px] flex-col items-center gap-4 rounded-xl bg-white p-6 max-md:bottom-0 max-md:animate-up-modal max-md:items-end max-md:bottom-modal md:center-modal"
        }
      >
        <Stack className={"w-full flex-center-row"}>
          <div className="flex w-full justify-center">
            <Typography
              variant={"h1"}
              component={"h3"}
              className={
                "w-fit justify-center text-center text-2xl font-semibold max-md:text-start"
              }
            >
              {title}
            </Typography>
          </div>
          <IconButton onClick={onClose} className="max-md:hidden">
            <WebShopIcon name="close" className="fill-blue" />
          </IconButton>
        </Stack>
        <Stack className="flex w-full flex-1 flex-col gap-6">
          {fields.map((props) => (
            <TextField control={control} {...props} key={props.name} />
          ))}
        </Stack>
        <Stack className="w-full justify-end gap-3 flex-center-row max-md:mt-auto">
          <Button
            onClick={onClose}
            variant="outlined"
            className="w-fit max-md:w-full"
          >
            скасувати
          </Button>
          <Button onClick={onSubmit} className="w-fit max-md:w-full">
            зберегти
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
